<template>
  <el-row>
    <el-button
      v-if="isSolicitud"
      type="warning"
      size="default"
      :disabled="props.disabled"
      @click="handleAnular"
      >{{ props.anularText }}</el-button
    >
    <el-button
      v-if="showConfirm"
      type="primary"
      size="default"
      :disabled="props.confirmDisabled"
      @click="handleConfirm"
      >{{ props.confirmText }}</el-button
    >
    <el-button
      type="default"
      size="default"
      @click="handleCancel"
      >{{ props.cancelText }}</el-button
    >
  </el-row>
</template>

<script setup>
import { useLoading } from '@/shared/composables/loading';

const emit = defineEmits(['onCancel', 'onConfirm', 'onAnular']);

const props = defineProps({
  disabled: { type: Boolean, default: false },
  showConfirm: { type: Boolean, default: true },
  showLoading: { type: Boolean, default: false },
  cancelText: { type: String, default: 'Cancelar' },
  confirmText: { type: String, default: 'Aceptar' },
  anularText: { type: String, default: 'Anular' },
  isSolicitud: { type: Boolean, default: false },
  confirmDisabled: { type: Boolean, default: false },
});

const handleCancel = async () => {
  await emit('onCancel');
};

const handleConfirm = async () => {
  if (props.showLoading === true) {
    useLoading().openLoading();
  }
  await emit('onConfirm');
};

const handleAnular = async () => {
  emit('onAnular');
};
</script>

<style scoped>
.el-row {
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid rgb(241, 241, 241);
}
</style>
